// Reusable text styles
export const textStyles = {
    // Headings
    h6: {
      fontWeight: 700,
      fontSize: '18px',
      lineHeight: '32px',
      letterSpacing: 0,
      verticalAlign: 'middle',
      color: '#17110D',
    },
    h6Small: {
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: 0,
      verticalAlign: 'middle',
    },
    
    // Body text
    bodyLarge: {
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: 0,
      verticalAlign: 'middle',
    },
    bodyMedium: {
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: 0,
      verticalAlign: 'middle',
    },
    bodySmall: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: 0,
      verticalAlign: 'middle',
    },
    bodyTiny: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: 0,
      verticalAlign: 'middle',
    },
    // Price text
    priceLarge: {
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: 0,
      verticalAlign: 'middle',
      color: '#17110D',
    },
    priceMedium: {
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: 0,
      verticalAlign: 'middle',
      color: '#17110D',
    },
    priceSmall: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: 0,
      verticalAlign: 'middle',
      textDecoration: 'line-through',
      color: '#B3907A',
    },
    savingsText: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: 0,
      verticalAlign: 'middle',
      color: '#4CAF50',
    },
    
    // Link text
    linkText: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      color: '#3D3C3C',
      letterSpacing: 0,
      verticalAlign: 'middle',
      textDecoration: 'underline',
      textDecorationStyle: 'solid',
      textDecorationSkip: 'auto',
      textDecorationThickness: 0,
      textDecorationColor: 'inherit',
      textUnderlineOffset: 0,
    },
    
    // Secondary text
    secondaryText: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: 0,
      verticalAlign: 'middle',
      color: '#3D3C3C',
    },
    
    // Button text
    buttonText: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: 0,
      verticalAlign: 'middle',
    },
    
    // Order summary text
    orderSummaryLabel: {
      fontSize: '14px',
      fontWeight: 700,
      color: '#17110D',
    },
    orderSummaryValue: {
      fontSize: '14px',
      fontWeight: 400,
      color: '#17110D',
    },
    orderSummarySubLabel: {
      ml: 4,
      color: '#ADA6A6',
      fontSize: '14px',
    },
    orderSummaryUnderlined: {
      fontSize: '14px',
      textDecoration: 'underline',
      color: '#17110D',
    },
    orderSummaryTotal: {
      fontWeight: 700,
      fontSize: 16,
      color: '#17110D',
    },
    orderSummaryTotalSub: {
      fontSize: '14px',
      color: '#17110D',
      fontWeight: 400,
    },
    orderSummaryTotalSubBold: {
      fontWeight: 700,
      marginRight: '4px',
    },
    orderSummaryTax: {
      fontSize: '14px',
      color: '#B31818',
    },
    orderSummaryNote: {
      color: 'text.secondary',
      fontSize: 13,
    },
    checkoutTitle: {
      fontWeight: 700,
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: 0,
      textAlign: 'center',
      verticalAlign: 'middle',
    },
    checkoutSubtitle: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: 0,
      textAlign: 'center',
      verticalAlign: 'middle',
    },
  } as const;